/**
 * Devolve um objeto no formato esperado pelo componente Menu e MenuLista
 *
 * @param codigo
 * @param descricao
 * @param icon
 * @param route
 * @param total = null
 * @param disabled = false
 * @param disabled_text = ''
 * @param breadcrumb_string = ''
 *
 * @returns {{
 *   codigo: *,
 *   descricao: *,
 *   icon: *,
 *   total: *,
 *   route: *,
 *   disabled: *,
 *   disabled_text: *,
 *   breadcrumb_string: *
 * }}
 */
export function formatarParaMenuLista(
    codigo,
    descricao,
    icon,
    route,
    total = null,
    disabled = false,
    disabled_text = '',
    breadcrumb_string = ''
) {
    return {
        codigo,
        descricao,
        icon,
        total,
        route,
        disabled,
        disabled_text,
        breadcrumb_string
    }
}

/**
 * Devolve um objeto no formato esperado pelo componente AppCarousel
 *
 * @param title
 * @param icon
 * @param command
 *
 * @returns {{title: *, icon: *, command: *}}
 */
export function formatarParaCarrossel(title, icon, command) {
    return {
        title,
        icon,
        command
    }
}
